import { render, staticRenderFns } from "./bookingDetail.vue?vue&type=template&id=2e8cfd90&scoped=true&"
import script from "./bookingDetail.vue?vue&type=script&lang=js&"
export * from "./bookingDetail.vue?vue&type=script&lang=js&"
import style0 from "./bookingDetail.vue?vue&type=style&index=0&id=2e8cfd90&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e8cfd90",
  null
  
)

export default component.exports